import { render, staticRenderFns } from "./UpdateTemplateAppDialogMasterSchool.vue?vue&type=template&id=415f1345&scoped=true"
import script from "./UpdateTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
export * from "./UpdateTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateTemplateAppDialogMasterSchool.vue?vue&type=style&index=0&id=415f1345&lang=css"
import style1 from "./UpdateTemplateAppDialogMasterSchool.vue?vue&type=style&index=1&id=415f1345&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f1345",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415f1345')) {
      api.createRecord('415f1345', component.options)
    } else {
      api.reload('415f1345', component.options)
    }
    module.hot.accept("./UpdateTemplateAppDialogMasterSchool.vue?vue&type=template&id=415f1345&scoped=true", function () {
      api.rerender('415f1345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/UpdateTemplateAppDialogMasterSchool.vue"
export default component.exports